export function extractResponsibleTargets(entry) {
  if (!entry || typeof entry !== "object") {
    return { userIds: [], groupIds: [], sectorIds: [], requester: false, requesterEmail: false };
  }

  const userIds = new Set();
  const groupIds = new Set();
  const sectorIds = new Set();

  const toBoolean = (value) => {
    if (typeof value === "boolean") return value;
    if (typeof value === "number") {
      if (value === 1) return true;
      if (value === 0) return false;
    }
    if (typeof value === "string") {
      const normalized = value.trim().toLowerCase();
      if (!normalized) return false;
      if (["1", "true", "yes", "sim", "on"].includes(normalized)) return true;
      if (["0", "false", "no", "nao", "off"].includes(normalized)) return false;
    }
    return false;
  };

  const add = (value, target) => {
    if (typeof value === "number" && Number.isFinite(value)) {
      target.add(value);
      return;
    }
    if (typeof value === "string" && value.trim()) {
      const parsed = Number(value);
      if (Number.isFinite(parsed)) {
        target.add(parsed);
      }
    }
  };

  const addMany = (values, target) => {
    if (!Array.isArray(values)) return;
    values.forEach((value) => add(value, target));
  };

  add(entry.userId, userIds);
  add(entry.groupId, groupIds);
  add(entry.sectorId, sectorIds);
  addMany(entry.userIds, userIds);
  addMany(entry.groupIds, groupIds);
  addMany(entry.sectorIds, sectorIds);

  return {
    userIds: Array.from(userIds),
    groupIds: Array.from(groupIds),
    sectorIds: Array.from(sectorIds),
    requester: toBoolean(entry.requester),
    requesterEmail: toBoolean(entry.requesterEmail),
  };
}

export function hasMultipleResponsibleTargets(entry) {
  const { userIds, groupIds, sectorIds, requester, requesterEmail } = extractResponsibleTargets(entry);
  if (groupIds.length > 0 || sectorIds.length > 0) return true;
  const total = userIds.length + groupIds.length + sectorIds.length + (requester ? 1 : 0) + (requesterEmail ? 1 : 0);
  return total > 1;
}
